import { FlatNode } from './types';

// static map data for dev purposes

export const devMindmapNodesList: FlatNode[] = [
  {
    version: 1,
    id: '2c9365c3-e06e-4cd4-b544-7e72305c4cb8',
    pid: null,
    width: 147,
    height: 59,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 59,
    textMinWidth: 147,
    text: '<span style="font-weight: 400;"><span style=""><span style="font-size: 26px;"><span style=""><span style=""><span style=""><span style=""><span style=""><span style=""><span style="color: rgb(0, 128, 0);"><span style="font-family: var(--font-family);"><span style="">hello</span></span></span> <span style="font-weight: 400;"><span style="">there</span></span></span></span></span></span></span></span></span></span></span><br>',
  },
  {
    version: 1,
    id: '4c1db548-7c9c-4006-b46b-3cef215863f0',
    pid: '2c9365c3-e06e-4cd4-b544-7e72305c4cb8',
    width: 77,
    height: 45,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 45,
    textMinWidth: 77,
    text: 'this is a',
  },
  {
    version: 1,
    id: '1e05d187-404d-4403-8a20-4eb71dc78f76',
    pid: '4c1db548-7c9c-4006-b46b-3cef215863f0',
    width: 67,
    height: 45,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 45,
    textMinWidth: 67,
    text: 'mind-',
  },
  {
    version: 1,
    id: 'b23144ff-cd79-4e53-9754-20b6044ed234',
    pid: '4c1db548-7c9c-4006-b46b-3cef215863f0',
    width: 59,
    height: 45,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 45,
    textMinWidth: 59,
    text: '<span style="font-family: monospace;">map!</span>',
  },
  {
    version: 1,
    id: '44b97e1c-f38b-4f62-b062-3a466474192e',
    pid: '2c9365c3-e06e-4cd4-b544-7e72305c4cb8',
    width: 286,
    height: 45,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 45,
    textMinWidth: 286,
    text: 'you have 3 ways to <span style="font-weight: 700;">rearrange nodes</span><br>',
  },
  {
    version: 1,
    id: 'e43d22f9-6aa2-4255-9685-21fafe2ae544',
    pid: '44b97e1c-f38b-4f62-b062-3a466474192e',
    width: 253,
    height: 66,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 253,
    text: 'drag-and-drop\n(right now only for mouse users)',
  },
  {
    version: 1,
    id: '49cc78c8-9a0a-4165-ad16-460bd21ee563',
    text: 'use the three-dot menu on the\ntop right of each node and\nselect "Copy &amp; Paste"',
    height: 87,
    width: 242,
    pid: 'e43d22f9-6aa2-4255-9685-21fafe2ae544',
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 87,
    textMinWidth: 242,
  },
  {
    version: 1,
    id: '96bb6e0b-85d8-41c9-a02b-de903025bcf9',
    text: 'use the menubar at the \nbottom of your screen ',
    height: 66,
    width: 193,
    pid: '49cc78c8-9a0a-4165-ad16-460bd21ee563',
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 193,
  },
  {
    version: 1,
    id: 'cbfc72e5-e9a2-49ce-9877-648b12c62bbc',
    pid: '2c9365c3-e06e-4cd4-b544-7e72305c4cb8',
    width: 223,
    height: 45,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 45,
    textMinWidth: 223,
    text: '<b>you can create nodes by ...</b>',
  },
  {
    version: 1,
    id: 'f40fcbb1-9966-4aaa-b201-80215ef1f1bb',
    pid: 'cbfc72e5-e9a2-49ce-9877-648b12c62bbc',
    width: 183,
    height: 66,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 183,
    text: 'using the blue buttons\naround each node',
  },
  {
    version: 1,
    id: '07e527c0-25b5-4295-8bb5-32c093dba430',
    text: 'using the menubar at the\nbottom of your screen<br>',
    height: 66,
    width: 209,
    pid: '3db7d4d3-248c-462d-8f97-1da84f453d56',
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 209,
  },
  {
    version: 1,
    id: '3db7d4d3-248c-462d-8f97-1da84f453d56',
    text: 'using the three-dot menu on the\ntop right of each node and\nselect "Knoten"',
    height: 87,
    width: 256,
    pid: 'f40fcbb1-9966-4aaa-b201-80215ef1f1bb',
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 87,
    textMinWidth: 256,
  },
  {
    version: 1,
    id: '45f01c82-c2fa-4a3f-8ac0-32efcf80e816',
    pid: '2c9365c3-e06e-4cd4-b544-7e72305c4cb8',
    width: 127,
    height: 45,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 45,
    textMinWidth: 127,
    text: 'navigate using\n',
  },
  {
    version: 1,
    id: 'cf9d1b2d-eb54-4a85-aa2b-ff2596e794ba',
    pid: '45f01c82-c2fa-4a3f-8ac0-32efcf80e816',
    width: 236,
    height: 87,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 87,
    textMinWidth: 236,
    text: '<span style="font-weight: 700;">keyboard &amp; mouse</span>:\n<span style="font-style: italic;">move</span>: right-click and drag\n<span style="font-style: italic;">zoom</span>: CTRL and mouse-wheel\n',
  },
  {
    version: 1,
    id: 'd6fa3b22-31c1-4660-a0f4-bfc18814ec5a',
    text: '<span style="font-weight: 700;">touchscreen</span>:\n<span style="font-style: italic;">zoom</span>: pinch\nmove: drag with 1 finger\n',
    height: 87,
    width: 197,
    pid: '45f01c82-c2fa-4a3f-8ac0-32efcf80e816',
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 87,
    textMinWidth: 197,
  },
  {
    version: 1,
    id: '634f22d0-359d-4a79-80c8-5dccd157f683',
    text: '<span style="font-weight: 700;">touchpad</span>:\n<span style="font-style: italic;">zoom</span>: pinch\nmove: drag with 2 fingers\n',
    height: 87,
    width: 203,
    pid: '45f01c82-c2fa-4a3f-8ac0-32efcf80e816',
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 87,
    textMinWidth: 203,
  },
  {
    version: 1,
    id: '82f4ad24-d361-4fe0-9fae-336fcaa63d59',
    pid: '915ec0a9-ced6-449d-86a2-3d96d6be7944',
    width: 260,
    height: 87,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 87,
    textMinWidth: 260,
    text: '<span style="font-family: monospace;">enter</span>: create neighbouring node\n<span style="font-family: monospace;">tab</span>: create child node\narrow key: move around\n',
  },
  {
    version: 1,
    id: '7f64853f-2690-4200-8ac1-ec99da5ae7b2',
    text: 'your typical <span style="font-family: monospace;"><span style="font-weight: 400;"><span style="">CTRL-C</span></span></span>, <span style="font-family: monospace;">CTRL-X</span>, <span style="font-family: monospace;">CTRL-V</span> and <span style="font-family: monospace;">DEL</span> also work!',
    height: 66,
    width: 300,
    pid: '82f4ad24-d361-4fe0-9fae-336fcaa63d59',
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 300,
  },
  {
    version: 1,
    id: 'b334a456-8e92-4bf6-8f68-9a2e88516b73',
    text: '<span style="font-family: monospace;">CTRL-Z</span> and CTRL-Y also work \n(<span style="font-size: 14px;"><span style="font-style: italic;">on most actions, it\'s still WIP ;)</span></span> )',
    height: 66,
    width: 239,
    pid: '82f4ad24-d361-4fe0-9fae-336fcaa63d59',
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 239,
  },
  {
    version: 1,
    id: '41166f67-d757-43e8-9b9b-651ec6b35766',
    pid: '2c9365c3-e06e-4cd4-b544-7e72305c4cb8',
    width: 300,
    height: 66,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 300,
    text: '<span style="background-color: rgb(173, 216, 230);">select some text</span> inside a node and a handy <span style="font-weight: 700;"><span style="color: rgb(128, 0, 128);">formatting </span></span>menu will appear!',
  },
  {
    version: 1,
    id: '9505656a-98e9-43af-ba9c-d15acc59cd46',
    pid: 'b23144ff-cd79-4e53-9754-20b6044ed234',
    width: 300,
    height: 87,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 87,
    textMinWidth: 300,
    text: "(it's hierarchy is drawn vertical right now, but i'm working on adding more layout, even text-only ones! 😄)",
  },
  {
    version: 1,
    id: 'b5256115-41b0-4af1-9015-2602b4a41ea0',
    pid: '2c9365c3-e06e-4cd4-b544-7e72305c4cb8',
    width: 307.125,
    height: 105,
    type: 'text',
    attachementMinHeight: 60,
    attachementMinWidth: 307.125,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 45,
    textMinWidth: 302,
    text: 'a node can have "Anhänge"',
    attachements: [
      {
        id: '0606316b-d5c6-43b7-a535-b5e191195e1b',
        name: 'My Github',
        type: 'link',
        url: 'https://github.com/sandro-salzmann',
        width: 122.281,
      },
      {
        id: '34405f42-86fa-4a2d-9621-b0068532b806',
        name: 'Picture (WIP)',
        type: 'file',
        isPreview: false,
        filePreviewHeight: 120,
        url: '',
        width: 146.844,
      },
    ],
  },
  {
    version: 1,
    id: 'bd42e489-9941-439a-a59f-13acaf2b02df',
    pid: '2c9365c3-e06e-4cd4-b544-7e72305c4cb8',
    width: 268,
    height: 66,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 268,
    text: 'left-click the background and drag\nto <span style="font-weight: 700;">select multiple nodes at once</span>',
  },
  {
    version: 1,
    id: '915ec0a9-ced6-449d-86a2-3d96d6be7944',
    pid: '2c9365c3-e06e-4cd4-b544-7e72305c4cb8',
    width: 280,
    height: 45,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 45,
    textMinWidth: 280,
    text: 'we also support keyboard shortcuts!',
  },
  {
    version: 1,
    id: '99fbc98a-19e2-4e4f-93cc-b41021788c9f',
    pid: 'b5256115-41b0-4af1-9015-2602b4a41ea0',
    width: 300,
    height: 66,
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 300,
    text: 'you can use the menubar on the bottom of your screen ...',
  },
  {
    version: 1,
    id: 'ed50ae6c-c706-4a9c-8c7e-87448e11f742',
    text: '... or the three dots on the top right of each node to add "Anhänge".',
    height: 66,
    width: 300,
    pid: '99fbc98a-19e2-4e4f-93cc-b41021788c9f',
    type: 'text',
    attachementMinHeight: 0,
    attachementMinWidth: 0,
    previewMinHeight: 0,
    previewMinWidth: 0,
    textMinHeight: 66,
    textMinWidth: 300,
  },
];
